module.exports = __webpack_public_path__ + "assets/048192cb5e76ba658305073a534978aa.png";